import {gql} from '@apollo/client'

export const GET_REPEATING_INVOICE = gql`
  query GetRepeatingInvoice($repeatingInvoiceId: ID!) {
    repeatingInvoice(id: $repeatingInvoiceId) {
      id
      account {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        billingEmail
        customerNumber
      }
      reference
      nextInvoiceDate
      nextInvoiceDueDate
      xeroLink
      billTo
      isSendable
      state
      lineItems
      taxType
      emailWithPlaceholders
      frequencyCount
      frequency
      endDate
    }
  }
`

export const CREATE_REPEATING_INVOICE = gql`
  mutation (
    $taxType: String
    $nextInvoiceDate: String
    $nextInvoiceDueDate: String
    $isSendable: Boolean
    $accountId: ID
    $reference: String
    $billTo: String
    $lineItems: JSON
    $frequencyCount: Int
    $frequency: String
    $endDate: String
  ) {
    repeatingInvoice(
      taxType: $taxType
      nextInvoiceDate: $nextInvoiceDate
      nextInvoiceDueDate: $nextInvoiceDueDate
      isSendable: $isSendable
      accountId: $accountId
      reference: $reference
      billTo: $billTo
      lineItems: $lineItems
      frequencyCount: $frequencyCount
      frequency: $frequency
      endDate: $endDate
    ) {
      id
      account {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        billingEmail
        customerNumber
      }
      reference
      nextInvoiceDate
      nextInvoiceDueDate
      xeroLink
      billTo
      isSendable
      state
      lineItems
      taxType
      emailWithPlaceholders
      frequencyCount
      frequency
      endDate
    }
  }
`

export const UPDATE_REPEATING_INVOICE = gql`
  mutation UpdateRepeatingInvoice(
    $repeatingInvoiceId: ID!
    $taxType: String
    $nextInvoiceDate: String
    $nextInvoiceDueDate: String
    $isSendable: Boolean
    $accountId: ID
    $reference: String
    $billTo: String
    $lineItems: JSON
    $emailWithPlaceholders: JSON
    $state: String
    $frequencyCount: Int
    $frequency: String
    $endDate: String
  ) {
    repeatingInvoice(
      id: $repeatingInvoiceId
      taxType: $taxType
      nextInvoiceDate: $nextInvoiceDate
      nextInvoiceDueDate: $nextInvoiceDueDate
      isSendable: $isSendable
      accountId: $accountId
      reference: $reference
      billTo: $billTo
      lineItems: $lineItems
      emailWithPlaceholders: $emailWithPlaceholders
      state: $state
      frequencyCount: $frequencyCount
      frequency: $frequency
      endDate: $endDate
    ) {
      id
      account {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        billingEmail
        customerNumber
      }
      reference
      nextInvoiceDate
      nextInvoiceDueDate
      xeroLink
      billTo
      isSendable
      state
      lineItems
      taxType
      emailWithPlaceholders
      frequencyCount
      frequency
      endDate
    }
  }
`
